import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Container, Card, Pagination } from '@jsluna/react'
import { withRouter } from 'react-router-dom'
import ResultList from './ResultList'
import Dropdown from '../Dropdown'
import Loading from './../../components/Loading'
import Search from './../../components/Search'

// import ReactGA from 'react-ga4'

class Reporting extends Component {
  state = {
    viewId: 0,
    data: [],
    defaultPageLength: 10,
    defaultActivePage: 1,
    searchTerms: ''
  }


  componentDidMount() {
    if (!this.props.reportTypes || this.props.reportTypes.length === 0) {
      this.props.fetchReportTypes()
    }

    if (this.props.setMenu === true) {
      this.props.setMenuSelectedState({ selectedMenu: '/reporting' })
    }

    if (this.props.selectedReportType) {
      this.setViewId(this.props.selectedReportType.id)
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.fetchEmbeddedReportSucceeded && !newProps.viewedEmbeddedReport) {
      this.props.history.push('/reportviewer')
    }
    this.setState({ searchTerms: newProps.reportOptions.searchTerms })
  }

  onDrillDown = (e, row) => {
    this.props.setReportRow(row)

    const reportType = this.props.reportTypes.find(report => report.id === this.state.viewId)
    this.props.setSelectedReportType(reportType)
    this.props.fetchEmbeddedReport(this.props.embeddedReportName)

    e.preventDefault()
  }

  setViewId = (id) => {
    this.setState({ viewId: id })
    this.props.setSelectedReportType(0)
  }

  getReport = (reportId, options) => {
    const report = this.reportTypeById(reportId)
    this.setState({ searchTerms: options.searchTerms })
    this.props.loadReport(report.type, options)
  }

  pageChange = (page) => {
    const options = {
      activePage: page,
      pageLength: this.state.defaultPageLength,
      searchTerms: this.state.searchTerms
    }
    this.getReport(this.state.viewId, options)
  }

  reportTypeById = (id) => {
    const reportTypes = this.props.reportTypes
    for (let i = 0; i < reportTypes.length; i += 1) {
      if (reportTypes[i].id === id) {
        return reportTypes[i]
      }
    }

    return {}
  }

  handleDropDownBoxChange = (e) => {
    const viewId = parseInt(e.target.value, 10)

    // ReactGA.event({
    //   category: "Choosing a report",
    //   action: `Chosen the report ${viewId}`,
    //   value: viewId 
    // })

    this.setState({ viewId })
    this.setState({ searchTerms: '' })
    const options = {
      activePage: 1,
      pageLength: this.state.defaultPageLength,
      searchTerms: ''
    }

    const parentReport = this.props.reportTypes.find(report => report.id === viewId)
    if (parentReport) {
      if (parentReport.subReport && parentReport.subReport.name) {
        this.setState({ subReportName: parentReport.subReport.name })
        this.props.setSelectedEmbeddedReport(parentReport.subReport.name)
      } else {
        this.setState({ subReportName: '' })
      }
    }

    // Don't use this.state.viewId as it hasn't updated
    this.getReport(viewId, options)
  }

  mapContractorsReport = (contractorsReport) => {
    const reportData = []
    if (contractorsReport) {
      contractorsReport.forEach((element) => {
        reportData.push({ name: element.fullName, jobRole: element.jobRole, id: element.id })
      })
    }
    return reportData
  }

  doSearch = (searchTerms) => {
    this.setState({ searchTerms })
    const options = {
      activePage: this.state.defaultActivePage,
      pageLength: this.state.defaultPageLength,
      searchTerms
    }

    this.getReport(this.state.viewId, options)
  }

  clearSearch = () => {
    this.doSearch('')
  }


  canViewReporting = () => {
    let isEnabled = false
    if (this.props.features.features) {
      this.props.features.features.filter((feature) => {
        if (feature.featureName.toUpperCase() === 'REPORTING') {
          isEnabled = feature.enabled
        }
        return isEnabled
      })
    }
    return isEnabled
  }


  headersForReportType = reportType => reportType.headers

  searchHeaderForReportType = reportType => reportType.reportTitle

  searchPlaceHolderForReportType = reportType => reportType.searchPlaceHolder

  dataForReportType = () => this.props.report.pagedReport

  render() {
    let headers = []
    let data = []
    let reportType
    let searchHeader
    let searchPlaceholder
    try {
      if (this.props.report.pagedReport.length > 0 && this.state.viewId > 0) {
        reportType = this.reportTypeById(this.state.viewId)
        headers = this.headersForReportType(reportType)
        data = this.dataForReportType()
        searchHeader = this.searchHeaderForReportType(reportType)
        searchPlaceholder = this.searchPlaceHolderForReportType(reportType)
      }
    } catch (e) {
      const Console = console
      Console.log(e)
    }

    if (!this.canViewReporting()) {
      return (
        <div>
          <Card>
            <p className="ln-u-text-align-left">Not found</p>
          </Card>
        </div>)
    }
    return (
      <div className="ln-c-header-body ln-u-soft-top" id="main-content">
        <Container soft>
          <div className="ln-o-grid ln-u-soft-left ln-u-soft-right">
            <div className="ln-o-grid__item ln-u-1/2@sm">
              <h3 className="reporting" style={{ marginLeft: '30px' }}>Reporting</h3>
            </div>
            <div className="ln-c-form-group ln-o-grid__item ln-u-push-1/6@sm ln-u-1/3@sm ln-u-1/1 ln-o-generic--div-without-padding">
              <div className="ln-o-grid ln-o-grid--center">
                <div className="ln-o-grid__item ln-u-1/4 ln-u-text-align-right">
                  <label htmlFor="cboJobRole" className="ln-c-label">
                    <span>View</span>
                    <span className="ln-c-label__info ln-u-visually-hidden">Required</span>
                  </label>
                </div>
                <div className="ln-o-grid__item ln-u-3/4">
                  {this.props.reportTypesLoading &&
                    <Loading title="Fetching available reports" />
                  }
                  <div className={this.props.reportTypesLoading === true ? 'ln-u-hidden' : ''}>
                    <Dropdown
                      items={this.props.reportTypesLoading === false ? this.props.reportTypes : []}
                      selectedItemId={this.state.viewId}
                      handleChange={e => this.handleDropDownBoxChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.viewId > 0 &&
          <div>
            <Card>
              <Search
                id={this.state.viewId}
                doSearch={this.doSearch}
                clearSearch={this.clearSearch}
                searchLabel={searchHeader}
                placeholderText={searchPlaceholder}
                key={this.state.viewId}
                value={this.state.searchTerms}
              />
            </Card>
            { this.props.report.pagedReport.length > 0 &&
            <div className="ln-c-card ln-u-soft-left ln-u-soft-right ln-u-soft-bottom">
              { (this.props.loading === true || this.props.fetchingEmbeddedReport) &&
                <Loading title="Fetching report" />
              }
              { this.props.loading !== true &&
                <div>
                  <ResultList
                    headers={headers}
                    data={data}
                    onDrillDown={this.state.subReportName !== '' ? this.onDrillDown : null}
                  />
                  <div className="ln-u-soft-top">
                    <Pagination
                      showFirstAndLast
                      fullWidth
                      current={this.props.reportOptions.activePage}
                      total={this.props.report.reportLength}
                      onChange={this.pageChange}
                    />
                  </div>
                </div>
              }
            </div>
            }
            { this.props.report.pagedReport.length === 0 && this.props.loading === false &&
            <Card>
              <p className="ln-u-text-align-center">No results found</p>
            </Card>
            }
          </div>
          }
        </Container>
      </div>
    )
  }
}

Reporting.propTypes = {
  fetchReportTypes: PropTypes.func.isRequired,
  loadReport: PropTypes.func.isRequired,
  report: PropTypes.shape({
    pagedReport: PropTypes.Array,
    reportLength: PropTypes.number
  }).isRequired,
  reportOptions: PropTypes.shape({
    activePage: PropTypes.number,
    pageLength: PropTypes.number
  }).isRequired,
  features: PropTypes.shape({
    features: PropTypes.Array
  }).isRequired,
  reportTypes: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string.isRequired })).isRequired,
  loading: PropTypes.bool,
  reportTypesLoading: PropTypes.bool,
  setMenu: PropTypes.bool.isRequired,
  setMenuSelectedState: PropTypes.func.isRequired,
  setSelectedEmbeddedReport: PropTypes.func.isRequired,
  setReportRow: PropTypes.func.isRequired,
  setSelectedReportType: PropTypes.func.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  fetchingEmbeddedReport: PropTypes.bool.isRequired,
  fetchEmbeddedReport: PropTypes.func.isRequired,
  embeddedReportName: PropTypes.string,
  selectedReportType: PropTypes.shape({ id: PropTypes.number.isRequired })
}

Reporting.defaultProps = {
  error: ['No errors defined', 'Another Error'],
  report: {
    pagedReport: [],
    reportLength: 0
  },
  reportOptions: {
    activePage: 1,
    pageLength: 10
  },
  loading: false,
  reportTypesLoading: false,
  features: {
    features: []
  },
  reportTypes: [],
  embeddedReportName: '',
  selectedReportType: { id: 0 }
}

export default withRouter(Reporting)



// WEBPACK FOOTER //
// ./src/components/Reporting/Reporting.jsx